<div class="support-container">
  <div class="page-header">
    <div class="page-title">Welcome to Support</div>
    <div class="search">
      <cc-input-search
        (onSearchSubmit)="handleSearch($event)"
      ></cc-input-search>
    </div>
  </div>
  <div class="page-content">
    <div class="content-header">Frequently Asked Questions</div>
    <div *ngIf="filterSupportList.length > 0" class="content">
      <div *ngFor="let item of filterSupportList" class="list-item">
        <div class="question">{{ item.title }}</div>
        <div class="answer">{{ item.content }}</div>
        <div class="image-container" *ngIf="item.image_url">
          <img alt="FAQ question image" class="image" [src]="item.image_url" />
        </div>
      </div>
    </div>
    <div *ngIf="!(filterSupportList.length > 0)" class="content">
      <p>No results</p>
    </div>
  </div>
  <div class="support" [ngClass]="{ show: showHint }">
    <div class="quick-help" (click)="openSupportLink()">
      <cc-icon
        width="24px"
        height="24px"
        [iconUrl]="'/assets/images/icons/support-icon.png'"
      ></cc-icon>
      <span>Submit a ticket for additional support</span>
    </div>
  </div>
</div>
